<mat-dialog-content>
    <div>Please confirm your password to continue.</div>

    <form>
        <input name="username" type="hidden" autocomplete="username" />

        <mat-form-field floatLabel="always" style="width: 100%">
            <mat-label>Confirm Password</mat-label>
            <input matInput name="password" type="password" [formControl]="passwordControl" autocomplete="current-password" />
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>

    <button
        mat-flat-button
        (click)="onLogInClicked()"
        color="primary"
        [disabled]="passwordControl.invalid || isLoggingIn"
        [appIndeterminateButtonLoading]="isLoggingIn"
    >
        Next
    </button>
</mat-dialog-actions>
